<div class="stimulus-activity-container">
  <h2 class="shortDirection" [innerHTML]="stimulus?.displayName"></h2>
  <!-- Create Activity directions -->
  <p class="directions" [innerHTML]="stimulus?.description"></p>

  <!-- Create Activity Stimuli (video, link, google map, etc.) -->
  @if (stimulus.stimuli) {
    <div>
      @for (taskStimuli of generateStimuliLinkArray(stimulus.stimuli); track taskStimuli) {
        <div class="stimuli">
          <div [ngClass]="getModuleTaskType(taskStimuli)">
            <section>
              @switch (getModuleTaskType(taskStimuli)) {
                @case ('youtube') {
                  <div>
                    <div class="videoWrapper" [innerHtml]="processStimuliLink_Module(taskStimuli)"></div>
                  </div>
                }
                @case ('vimeo') {
                  <div>
                    <iframe
                      width="800"
                      height="480"
                      [src]="processStimuliLink_Module(taskStimuli)"
                      frameborder="0"
                      webkitallowfullscreen
                      mozallowfullscreen
                      allowfullscreen
                      allow="microphone *; camera *;"
                      title="Vimeo iframe"
                    ></iframe>
                  </div>
                }
                @case ('https') {
                  <div>
                    <div [innerHtml]="processStimuliLink_Module(taskStimuli)"></div>
                  </div>
                }
                @case ('http') {
                  <div>
                    <div [innerHtml]="processStimuliLink_Module(taskStimuli)"></div>
                  </div>
                }
                @case ('gmap') {
                  <div>
                    <div [innerHtml]="processStimuliLink_Module(taskStimuli)"></div>
                  </div>
                }
                @case ('inews') {
                  <div>
                    <div [innerHtml]="processStimuliLink_Module(taskStimuli)"></div>
                  </div>
                }
                @case ('emcl') {
                  <div>
                    <div [innerHtml]="processStimuliLink_Module(taskStimuli)"></div>
                  </div>
                }
              }
            </section>
          </div>
        </div>
      }
      @if (stimulus?.stimuliDirection) {
        <section class="stimuliDirection">
          <p class="margin-0" [innerHtml]="stimulus?.stimuliDirection"></p>
        </section>
      }
    </div>
  }
  <!-- DEFAULT (process as link) -->
  <div fxLayout="column">
    @if (stimulus?.url) {
      <div class="link" [innerHTML]="stimulus_url"></div>
    }

    @if (getMediaTypeFromFile(stimulus?.file) === 'image') {
      <div class="file" fxLayoutAlign="center center">
        <div class="imageWrapper"><img [src]="stimulus_file$ | async" alt="Activity Image" /></div>
      </div>
    }
    @if (getMediaTypeFromFile(stimulus?.file) === 'video') {
      <div class="file" fxLayoutAlign="center center">
        <video class="video" playsinline controls [src]="stimulus_file$ | async"></video>
      </div>
    }
    @if (getMediaTypeFromFile(stimulus?.file) === 'other') {
      <div class="file" fxLayoutAlign="center center">
        <a target="_blank" [href]="stimulus_file$ | async"><span class="assignment-view">View Resource Document</span></a>
      </div>
    }
  </div>

  <!--
  <div class="responseTypeSet">
    <span class="responseType"> Response Type:</span>
    <span [ngSwitch]="stimulus?.responseType" >
      <span  *ngSwitchCase="'file'"> Upload a file or provide a URL</span>
      <span  *ngSwitchCase="'text'"> Write a short answer</span>
      <span  *ngSwitchCase="'both'"> Write a short answer and upload file/URL</span>
      <span  *ngSwitchCase="'none'"> No student response required</span>
    </span>
  </div>
  -->
</div>
